export default __webpack_public_path__ + "static/media/mkk2_light.1c9c5381.png";